import { enableProdMode,importProvidersFrom  } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Cesium from 'cesium';
import { Ion } from 'cesium';

if (environment.production) {
  enableProdMode();
}
(window as Record<string, any>)['CESIUM_BASE_URL'] = '/assets/cesium/';
if (environment.cesiumAccessToken) {
Ion.defaultAccessToken = environment.cesiumAccessToken;
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
